var _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewCircles = function SvgNewCircles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 600 600"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 295,
    stroke: "#BDC4FF",
    strokeDasharray: "10 10",
    strokeWidth: 2,
    opacity: 0.67
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 195,
    stroke: "#BDC4FF",
    strokeDasharray: "4 4",
    strokeWidth: 2,
    opacity: 0.67
  })));
};
export default SvgNewCircles;